import { GetAccountProfileUserResponseMessage } from '../services/evergent/account/model/account-profile-subscription.response.model';
import {
  AccountServiceMessage,
  GetEntitlementsResponseMessage,
} from '../services/evergent/payment/model/get-entitlements/get-entitlements.response.model';
import moment from 'moment';
import { KEYS } from './constants/storage.constants';
import { LANG } from '../common/const/common.const';

// eslint-disable-next-line no-shadow
export enum AhaUserType {
  ANONYMOUS = 'ANONYMOUS',
  REGISTERED = 'REGISTERED',
  TELUGU_SUBSCRIBED = 'TELUGU_SUBSCRIBED',
  TAMIL_SUBSCRIBED = 'TAMIL_SUBSCRIBED',
  TELUGU_CANCELLED = 'TELUGU_CANCELLED',
  TAMIL_CANCELLED = 'TAMIL_CANCELLED',
  CANCELLED_GOLD = 'CANCELLED_GOLD',
  PREMIUM = 'PREMIUM',
}

export enum UserCategoryType {
  TELUGU = 'TELUGU',
  TAMIL = 'TAMIL',
  GOLD = 'GOLD',
  NA = 'NA',
}

export const getDateOrdinal = (dateObj: Date, isTvod: boolean): string => {
  const date = moment(new Date(dateObj));
  const day = date.format('DD');
  const month = date.format('MMM');
  const year = date.format('YYYY');
  const hour = date.format('hh');
  const min = date.format('mm');
  const period = date.format('A');

  const getOrdinalSuffix = (day: number) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    } else {
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    }
  };

  const ordinalSuffix = getOrdinalSuffix(parseInt(day));

  return isTvod
    ? `${day}${ordinalSuffix} ${month} ${year}, ${hour}:${min} ${period}`
    : `${day}${ordinalSuffix} ${month} ${year}`;
};

export const dateConversion = (date: number) => {
  return new Date(date)
    .toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    .replace('at', ',')
    .replace(' ,', ',');
};

export const getSubscriptionStatus = (
  account?: GetAccountProfileUserResponseMessage
): void => {
  const subscriptionStatus =
    account?.GetAccountProfileResponseMessage?.subscriptionStatus;
  localStorage.setItem(
    'subscriptionStatus',
    subscriptionStatus?.toString() || ''
  );
  // Validating catalogues if user is subscribed
  if (subscriptionStatus) {
    const subscribedCatalogue = account?.GetAccountProfileResponseMessage
      ?.subscribedCatalogue
      ? account?.GetAccountProfileResponseMessage?.subscribedCatalogue
          .toString()
          .toUpperCase()
      : '';
    // Validating subscribe button
    if (
      (subscribedCatalogue.includes(LANG.TM.v) &&
        subscribedCatalogue.includes(LANG.TG.v)) ||
      (subscribedCatalogue.includes(LANG.TG.v) &&
        localStorage.getItem(KEYS.WATCH_LANGUAGE) === LANG.TG.v) ||
      (subscribedCatalogue.includes(LANG.TM.v) &&
        localStorage.getItem(KEYS.WATCH_LANGUAGE) === LANG.TM.v)
    ) {
      // Is allowed to see premium content
      localStorage.setItem('subscription', 'premium');
    } else if (subscribedCatalogue === '') {
      localStorage.setItem('subscription', 'premium');
    } else {
      localStorage.setItem('subscription', 'free');
    }
  }
};

export const getProfileSubscriptionInfo = (subscription?: any) => {
  localStorage.setItem(
    'status',
    subscription?.AccountServiceMessage.filter(
      (res: AccountServiceMessage) => !res?.isContent
    )?.[0]?.status
  );
  return subscription?.AccountServiceMessage.filter(
    (res: AccountServiceMessage) => !res?.isContent
  )?.[0]?.status;
};

export const getUserType = (
  accountProfileResult: GetAccountProfileUserResponseMessage,
  entitlementResult: GetEntitlementsResponseMessage
): AhaUserType => {
  try {
    const entitlements =
      entitlementResult?.GetEntitlementsResponseMessage
        ?.AccountServiceMessage[0];
    const subscriptionStatus =
      accountProfileResult?.GetAccountProfileResponseMessage
        ?.subscriptionStatus;
    const subscribedCatalogue: string = accountProfileResult
      ?.GetAccountProfileResponseMessage?.subscribedCatalogue
      ? accountProfileResult?.GetAccountProfileResponseMessage?.subscribedCatalogue
          ?.toString()
          .toUpperCase()
      : '';

    if (
      subscriptionStatus === true &&
      entitlements.name === 'urn:package:combo' &&
      entitlements.status.toLowerCase() === 'final bill'
    ) {
      sessionStorage.setItem(
        'AhaUserType',
        AhaUserType.CANCELLED_GOLD.toString()
      );
      return AhaUserType.CANCELLED_GOLD;
    }

    if (
      subscriptionStatus === true &&
      subscribedCatalogue.includes('TAMIL') &&
      entitlements.status.toLowerCase() === 'final bill'
    ) {
      sessionStorage.setItem(
        'AhaUserType',
        AhaUserType.TAMIL_CANCELLED.toString()
      );
      return AhaUserType.TAMIL_CANCELLED;
    }

    if (
      subscriptionStatus === true &&
      subscribedCatalogue.includes('TELUGU') &&
      entitlements.status.toLowerCase() === 'final bill'
    ) {
      sessionStorage.setItem(
        'AhaUserType',
        AhaUserType.TELUGU_CANCELLED.toString()
      );
      return AhaUserType.TELUGU_CANCELLED;
    }

    if (
      subscriptionStatus === true &&
      entitlements.name === 'urn:package:combo'
    ) {
      sessionStorage.setItem('AhaUserType', AhaUserType.PREMIUM.toString());
      return AhaUserType.PREMIUM;
    }

    if (subscriptionStatus === false) {
      sessionStorage.setItem('AhaUserType', AhaUserType.REGISTERED.toString());
      return AhaUserType.REGISTERED;
    }

    if (
      subscriptionStatus === true &&
      subscribedCatalogue?.includes('TELUGU')
    ) {
      sessionStorage.setItem(
        'AhaUserType',
        AhaUserType.TELUGU_SUBSCRIBED.toString()
      );
      return AhaUserType.TELUGU_SUBSCRIBED;
    } else if (
      subscriptionStatus === true &&
      subscribedCatalogue?.includes('TAMIL')
    ) {
      sessionStorage.setItem(
        'AhaUserType',
        AhaUserType.TAMIL_SUBSCRIBED.toString()
      );
      return AhaUserType.TAMIL_SUBSCRIBED;
    }

    sessionStorage.setItem('AhaUserType', AhaUserType.ANONYMOUS.toString());

    return AhaUserType.ANONYMOUS;
  } catch (e) {
    sessionStorage.setItem('AhaUserType', AhaUserType.ANONYMOUS.toString());
    return AhaUserType.ANONYMOUS;
  }
};

export const setShowDolbyAudioOnUserType = (userType: AhaUserType): string => {
  /**
   *  This is very strange requirement show the dolby logo on below conditions
   *
   * AhaUserType.ANONYMOUS
   * AhaUserType.REGISTERED
   * AhaUserType.PREMIUM
   * AhaUserType.CANCELLED_GOLD
   */
  if (
    userType === AhaUserType.ANONYMOUS ||
    userType === AhaUserType.REGISTERED ||
    userType === AhaUserType.PREMIUM ||
    userType === AhaUserType.CANCELLED_GOLD
  ) {
    sessionStorage.setItem('showDolbyLogo', 'true');
    return 'true';
  } else {
    sessionStorage.setItem('showDolbyLogo', 'false');
    return 'false';
  }
};
